import moment from 'moment/moment';
import { ClickableCellRenderer } from '../../../../../../../components/AGGrid/cell-renderers/clickable';
import {CustomHeader} from "../../../../../../../components/AGGrid/cell-renderers/custom-header";

export const id = {
    cellRenderer: 'agGroupCellRenderer',
    field: 'id',
    headerName: 'ID',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'linkedProducts',
    }
};

export const title = {
    field: 'title',
    headerName: 'Title',
    tooltipField: 'title',
    flex: 4,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'productTitle',
        page: 'linkedProducts',
    }
};

export const verified = (onOpenEditModal) => ({
    headerName: 'Verified',
    cellRenderer: ClickableCellRenderer(onOpenEditModal, 'fa-circle-check'),
    valueGetter: (data) => {
        console.log(data.data.verified)
        return data.data.verified === 'Yes' ? 'Verified' : 'Not Verified';
    },
    flex: 3,
});

export const added = {
    headerName: 'Added',
    valueGetter: (data) => {
        return data?.data.addedDate && moment(data.data.addedDate).format('MM/DD/YYYY');
    },
    flex: 3,
};
